import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, RangeControl, ColorPalette } from '@wordpress/components';
import { t } from "drupal";

const SidePanel = ({ numCols, updateNumCols, firstBlockType, firstColor, firstColorClass, setAttributes }) => {

    const backgroundOptions = [
        { name: 'Purple', color: '#32006e', class: 'purple' },
        { name: 'Dark Grey', color: '#404040', class: 'darkgrey' },
        { name: 'Lite Grey', color: '#e5e5e5', class: 'litegrey' },
        { name: 'White', color: '#ffffff', class: 'white' },
    ];

    // console.log("sidePanel: ", { numCols, firstBlockType, firstColor, firstColorClass });

    return (
        <InspectorControls>
            <PanelBody title={t('Settings', 'deohs-gutenberg-blocks')}>
                <RangeControl
                    label={t('Number of Columns per Row', 'deohs-gutenberg-blocks')}
                    value={numCols}
                    onChange={updateNumCols}
                    min={2}
                    max={4}
                />
                <p>Select number of columns per row. Select the background color to apply to all cards. Then click on "Add card for card group" to choose type of card to add it. Keep adding additional ones with the button. </p>
            </PanelBody>

            <PanelBody title="Card Background Color" initialOpen={true}>
                <ColorPalette
                    value={firstColor}
                    colors={backgroundOptions.map(({ name, color }) => ({ name, color }))}
                    onChange={(color) => {
                        const selected = backgroundOptions.find((opt) => opt.color === color);
                        if (selected) {
                            setAttributes({
                                firstColor: selected.color,
                                firstColorClass: selected.class,
                            });
                        }
                    }}
                />
            </PanelBody>
        </InspectorControls>
    );
};

export default SidePanel;
